/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my text sent to a server?`)
};

const es_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se envía mi texto a un servidor?`)
};

const de_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Text an einen Server gesendet?`)
};

const nl_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn tekst naar een server gestuurd?`)
};

const fr_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon texte est-il envoyé à un serveur ?`)
};

const it_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio testo viene inviato a un server?`)
};

const pt_br2_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é enviado para um servidor?`)
};

const pt_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu texto é enviado para um servidor?`)
};

const ja_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストはサーバーに送信されますか?`)
};

const zh_hg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文本会被发送到服务器吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq3_q", locale)
	if (locale === "en") return en_hg_faq3_q(inputs)
	if (locale === "es") return es_hg_faq3_q(inputs)
	if (locale === "de") return de_hg_faq3_q(inputs)
	if (locale === "nl") return nl_hg_faq3_q(inputs)
	if (locale === "fr") return fr_hg_faq3_q(inputs)
	if (locale === "it") return it_hg_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq3_q(inputs)
	if (locale === "pt") return pt_hg_faq3_q(inputs)
	if (locale === "ja") return ja_hg_faq3_q(inputs)
	return zh_hg_faq3_q(inputs)
};